﻿import React from 'react';
import InTime_Logo from '@Elements/SideNavigation/InTime_Logo';
import Navigation from '@Elements/SideNavigation/Navigation';

const Side_Navigation = (): JSX.Element => {
    return (
        <section className="Side_Navigation">
            <InTime_Logo />
            <Navigation />
        </section>
    );
}

export default React.memo(Side_Navigation);